import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import UserQueryKeys from './UserQueryKeys';
export const userQueryKeys = new UserQueryKeys('user');
export const useSetCurrentUserCache = () => {
    const queryClient = useQueryClient();
    return useCallback((user) => queryClient.setQueryData(userQueryKeys.getCurrentUser(), user), [queryClient]);
};
